import { Item as TableItem } from '@baemingo/table-events/dist/types';
import { CartItem, LocalItem } from '~Types';
import { exactMatch } from './combineArticles';

type ItemSelection = {
  selectedItem: TableItem | CartItem | LocalItem;
  items: (TableItem | CartItem)[];
  compressedCart: boolean;
  selectedItems: string[];
};

export const selectItem = ({
  selectedItem,
  items,
  compressedCart,
  selectedItems,
}: ItemSelection) => {
  if (compressedCart) {
    const selectedItemIds = items
      .filter((item) => exactMatch(item, selectedItem))
      .map((i) => i.id);

    if (selectedItemIds.some((sid) => selectedItems.includes(sid))) {
      return selectedItems.filter((item) => !selectedItemIds.includes(item));
    } else {
      return [...selectedItems, ...selectedItemIds];
    }
  } else {
    if (selectedItems.includes(selectedItem.id)) {
      return selectedItems.filter((item) => item != selectedItem.id);
    } else {
      return [...selectedItems, selectedItem.id];
    }
  }
};
